import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {
    CnCommissionModelObjectBaseViewComponent
} from '../cn-commission-model-object-base-view/cn-commission-model-object-base-view.component';
import {
    MvsObjectNavigationService
} from 'features/core/shared/navigation/mvs-object-navigation.service';

/**
* Side (compact) view of the CommissionModel object component (FR-8).
*
* Shows the essential left-nav sections in a side/mini-side context:
* Allgemein / Regeln. Full configuration happens in the full view.
*/
@Component({
    selector: 'mvs-cn-commission-model-side',
    templateUrl: './cn-commission-model-side.component.html',
    styleUrls: ['./cn-commission-model-side.component.scss'],
    standalone: false
})
export class CnCommissionModelSideComponent extends CnCommissionModelObjectBaseViewComponent
    implements OnInit, OnChanges, OnDestroy {

    constructor(
        protected override activatedRoute: ActivatedRoute,
        protected override navigationService: MvsObjectNavigationService
    ) {
        super(activatedRoute, navigationService);
    }

    /**
    * Compact left-nav items (G6: action-based, fa-solid icons, German labels with umlauts).
    */
    loadSideBarMenuItems(): void {
        this.navigationItems = [
            {
                label: 'Allgemein',
                action: 'cn.CommissionModel',
                tooltip: 'Allgemein',
                icon: 'fa-solid fa-sliders text-xl',
                toggleable: false,
                default: true
            },
            {
                label: 'Regeln',
                action: 'cn.CommissionRule',
                tooltip: 'Regeln',
                icon: 'fa-solid fa-folder-tree text-xl',
                toggleable: false,
                default: false
            }
        ];
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.loadSideBarMenuItems();
        this.initComponent();
    }

    /**
    * Re-render the section widgets when the bound objectIdentifier changes.
    * Delegates to the shared base view (G2.3 / G4.6).
    */
    override ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
    }
}
